import React, {
	useEffect, useState
}from "react"
import {
	Card, Form, Checkbox
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	userActions
}from "../../../store/actions/user"
import i18n from "./localization"
import "./style.css"

const Roles = (props) => {
	const { userId } = props
	const dispatch = useDispatch()
	const [filteredRoles, setFilteredRoles] = useState([])
	const rolesDto = useSelector((state) => state.userReducer.rolesDto)
	const isRu = useSelector((state) => state.globalReducer.isRu)

	useEffect(() => {
	  dispatch(userActions.getRoles({ userId }))
	}, [])

	/*
	 * useEffect(() => {
	 * 	if (rolesDto)
	 * 		setFilteredRoles(rolesDto.filter((e) => e.checked))
	 * }, [rolesDto])
	 */

	return (
		<Form.Item
			className="roles-checkbox"
			label={ i18n.rolesInfoTitle[isRu] }
			labelAlign="left"
			labelCol={ {
				// span: 6
			} }
			wrapperCol={ {
				span   : 8,
				offset : 1
			} }
		>
			{
				rolesDto?.length > 0 && rolesDto.map((role, index) => {
					return (
						<Form.Item
							key={ index }
							className="checkbox-form-item"
							initialValue={ role.checked }
							valuePropName="checked"
						>
							<Checkbox
								checked={ role.checked }
								disabled={ userId }
							>
								{ role[`description${ isRu ? "" : "Bel" }`] }

							</Checkbox>
						</Form.Item>
					)
				})
			}
		</Form.Item>
	)
}

export default Roles
